import React from "react";
import { Card, List, Typography, Tag, Button } from "antd";
import { InfoCircleOutlined, RightOutlined } from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

// 常見行為與飼育文章清單
const articles = [
    {
        id: "cat-friendly-space",
        title: "打造貓咪友善空間的五大原則",
        summary: "不管你是新手飼主還是資深鏟屎官，了解如何透過環境豐富化設計出適合貓咪的空間，能讓養貓生活更幸福。",
        date: "2024-07-06",
        tag: "貓咪飼養",
        color: "blue",
        path: "https://www.catraws.com/behaviour/guide/cat-friendly-space/"
    },
    {
        id: "introduce-cat",
        title: "如何讓新舊貓和平相處？隔離介紹四步驟完美上手",
        summary: "兩貓相處並非擺在一起就會變好。透過正確的隔離與介紹步驟，循序漸進地讓新貓融入，避免家庭戰爭。",
        date: "2026-02-07",
        tag: "貓咪飼養",
        color: "purple",
        path: "https://www.catraws.com/behaviour/guide/introduce-cat/"
    },
];

const Guideline = () => {
    return (
        <div style={{ padding: 20, maxWidth: 1000, margin: "0 auto", minHeight: "100vh" }}>
            <div style={{ marginBottom: 30, textAlign: "left" }}>
                <Title level={2} style={{ color: "#1677ff" }}>
                    <InfoCircleOutlined style={{ marginRight: 10 }} />
                    飼育指南
                </Title>
                <Text type="secondary">
                    學習正確的寵物行為知識與環境規劃，成為寵物心中最懂他的好夥伴。
                </Text>
            </div>

            <List
                grid={{ gutter: 20, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
                dataSource={articles}
                renderItem={(item) => (
                    <List.Item>
                        <Card
                            hoverable
                            style={{ borderRadius: 12, height: "100%", display: "flex", flexDirection: "column" }}
                            bodyStyle={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
                        >
                            <div style={{ marginBottom: 12 }}>
                                <Tag color={item.color}>{item.tag}</Tag>
                                <Text type="secondary" style={{ float: "right" }}>{item.date}</Text>
                            </div>

                            <Title level={4} style={{ marginTop: 0 }}>{item.title}</Title>

                            <Paragraph ellipsis={{ rows: 2 }} type="secondary" style={{ flexGrow: 1 }}>
                                {item.summary}
                            </Paragraph>

                            <Button
                                type="link"
                                icon={<RightOutlined />}
                                style={{ padding: 0, marginTop: "auto" }}
                                onClick={() => window.open(item.path, "_blank")}
                            >
                                閱讀全文
                            </Button>
                        </Card>
                    </List.Item>
                )}
            />
        </div>
    );
};

export default Guideline;